/** Köprü arayüzünün metinleri. */

import type { TranslationBundle } from '../../shell/bridge.ts';

export const TEXTS: TranslationBundle = {
  en: {
    fl_firm_t: 'Link a Client',
    fl_firm_d: 'Generate a code and give it to your client. They enter and confirm it in their own account.',
    fl_new: '+ Generate Invite Code', fl_code_hint: 'valid 10 minutes · single use',
    fl_cust_t: 'Link My Bookkeeper', fl_cust_d: 'Enter the code your bookkeeper gave you.',
    fl_ph: 'TEK-XXXX-XX', fl_check: 'Continue', fl_confirm: 'Confirm and Link', fl_cancel: 'Cancel',
    fl_asks: 'wants to add you as a client.',
    fl_will: 'If you confirm, they will be able to view your transactions, documents, contacts and templates, and add or correct transactions, documents and contacts. They cannot delete anything or see your payments. Every change is recorded along with who made it. You can disconnect at any time, and your data stays with you.',
    fl_linked: 'Linked', fl_none: 'No links yet.', fl_revoke: 'Disconnect',
    fl_revoked: 'Link removed.', fl_ok: '✓ Linked.',
    fl_copy: 'Copy', fl_copied: 'Copied',
    fl_qr: 'Show QR', fl_qr_hint: 'Your client can scan this with their phone',
    fl_qr_fail: 'QR unavailable — share the code manually.', fl_nolink: 'Connection unavailable',
  },
};
